<template>
    <div class="ph-courses-main">
        <el-backtop ></el-backtop>
        <hpheader></hpheader>

        <div class="ph-courses-container">
            <position-bar :positionNav="positionNav">
            </position-bar>
<!--            <div class="tabs">-->
<!--                <div class="tab" v-for="(item,index) in tabs">-->
<!--                    <span :style="{color: index == tabsIndex ? themeColor : '#606266'}" @click="tabHandle(index)">{{ item }} <i :class="index == tabsIndex ? 'on' : ''" :style="{backgroundColor:themeColor}"></i> </span>-->
<!--                </div>-->
<!--            </div>-->

            <div class="ph-courses-list" v-if="tabsIndex == 0">
                <div class="ph-courses-item" v-for="item in webinar.list" @click="toDetail(item)">
                    <div class="image">
                        <img :src="item.poster" alt="">
                    </div>
                    <div class="text">
                        <h3>{{ item.title }}</h3>
                    </div>
                </div>
            </div>

            <div class="ph-courses-list" v-else>
                <div class="ph-courses-item" v-for="item in webinar.list" @click="toDetail(item)">
                    <div class="image">
                        <img :src="item.poster" alt="">
                    </div>
                    <div class="text">
                        <h3>{{ item.title }}</h3>
                    </div>
                </div>
            </div>


<!--            <div class="ph-academy-container" v-else>-->
<!--                <div class="seach-vidoverall">-->
<!--                    <div class="vidoverall-item" v-for="(item,index) in video.list" :key="index">-->
<!--                        <div class="vidallitem-img">-->
<!--                            <video :src="item.video" :poster="item.poster" controls></video>-->
<!--                        </div>-->
<!--                        <div class="vidallitem-title">{{item.title}}</div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->

        </div>
        <div ref="bottom" style="width: 100%;height: .5rem;"></div>

        <hpfooter></hpfooter>
    </div>
</template>

<script>
    import hpheader from '../../common/hpheader.vue'
    import hpfooter from '../../common/hpfooter.vue'
    import {session} from '../../storage/storage.js';
    import positionBar from '../../components/ph-position-bar.vue'


    export default {
        name: "phcourses",
        data(){
            return {
                webinar:{
                    list:[],
                    page:{
                        current_page:1,
                        last_page:1
                    }
                },
                video:{
                    list:[],
                    page:{
                        current_page:1,
                        last_page:1
                    },
                },
                isLoad:false,
                positionNav:[
                    {
                        title:'Home',
                        path:'/pchome',
                    },
                    {
                        title:'Academy',
                        path:'',
                    },
                    {
                        title:'Courses',
                        path:'',
                    },
                ],
                tabs:['Online','Off-line'],
                tabsIndex:0,
                themeColor:session.get('channel_id')==1?'#e62129':session.get('channel_id')==2?'#1a4698':'#5f5d5d'
            }
        },
        components:{
            hpfooter,
            hpheader,
            positionBar
        },
        created(){
            this.ress()

            if (!(navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
                this.$router.push({path:'./pccourses'})
                return
            }
        },
        mounted(){
            document.addEventListener('scroll',this.handleScroll,false)
            this.$once('hook:beforeDestroy', () => {
                document.removeEventListener('scroll', this.handleScroll,false)
            })
            this.getWebinarList()
        },
        methods:{
            getVideoList(){
                var data = {
                    lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
                    channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
                    page:this.video.page.current_page
                }
                this.$api.get_cacdemy_courses_hands_on_list(data).then(res => {
                    this.video.list = this.video.list.concat(res.data.data)
                    this.video.page.current_page = res.data.current_page
                    this.video.page.last_page = res.data.last_page
                    this.isLoad = this.video.page.current_page >= this.video.page.last_page ? true : false
                })
            },
            getWebinarList(){
                var data = {
                    lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
                    channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
                    page:this.webinar.page.current_page
                }
                this.$api.get_cacdemy_courses_webinar_list(data).then(res => {
                    this.webinar.list = this.webinar.list.concat(res.data.data)
                    this.webinar.page.current_page = res.data.current_page
                    this.webinar.page.last_page = res.data.last_page
                    this.isLoad = this.webinar.page.current_page >= this.webinar.page.last_page ? true : false
                })
            },
            toDetail(item){
                this.$router.push({path: '/ph-webinar-detail',query:{id:item.id}})
            },
            handleScroll(){
                if(!this.$utils.isElementNotInViewport(this.$refs.bottom)){
                    this.load()
                }
            },
            load(){
                if(this.isLoad){
                    return
                }
                this.isLoad = true
                const _this = this
                _this.webinar.page.current_page++
                _this.getWebinarList()
            },
            tabHandle(index){
                const _this = this
                _this.isLoad = false
                _this.tabsIndex = index
                if(index == 1){
                    this.video.list = []
                    this.video.page.current_page = 1
                    _this.getVideoList()
                }else {
                    this.webinar.list = []
                    this.webinar.page.current_page = 1
                    _this.getWebinarList()
                }
            },
            ress(){
                var html = document.documentElement; //获取根元素
                var designWidth = 750; //设计稿宽度
                //html.clientWidth 视口宽度
                html.style.fontSize = html.clientWidth / designWidth * 100 + "px"; //设置字体大小
            },
        }
    }
</script>
<style>
    .ph-courses-main{
        background: #FFF;
        padding-top: 0.88rem;
    }
    .ph-courses-container {
        padding: 0 .3rem;
    }
    .ph-courses-container .ph-position-bar {
        margin: .3rem 0;
    }
    .ph-courses-main .ph-courses-container .tabs {
        display: flex;
        margin-top: .5rem;
    }
    .ph-courses-main .ph-courses-container .tabs .tab {
        font-size: .28rem;
        color: #606266;
        flex: 1;
        text-align: center;
    }
    .ph-courses-main .ph-courses-container .tabs .tab span {
        position: relative;
        padding: .1rem 0;
    }
    .ph-courses-main .ph-courses-container .tabs .tab span i {
        display: block;
        height: 3px;
        position: absolute;
        bottom: 0;
        left: 50%;
        width: 0;
        transform: translate(-50%,0);
        transition: width .3s linear 0s;
    }
    .ph-courses-main .ph-courses-container .tabs .tab span i.on {
        width: 100%;
    }
    .ph-courses-list {
        display: flex;
        flex-wrap: wrap;
        margin-top: 0;
        justify-content: space-between;
    }
    .ph-courses-list .ph-courses-item {
        width: 3.3rem;
        box-shadow: 0 4px 8px 0 rgba(0,0,0,.1);
        margin-top: .4rem;
        border-radius: 20px;
        overflow: hidden;
    }
    .ph-courses-list .ph-courses-item .image img{
        width: 100%;
        display: block;
    }
    .ph-courses-list .ph-courses-item .text {
        font-size: .24rem;
        padding: .2rem;
    }
    .ph-courses-list .ph-courses-item .text h3 {
        font-weight: 400;
    }

    .ph-courses-main .ph-academy-container {
        margin-top: .3rem;
    }
    .ph-courses-main .ph-academy-container .seach-vidoverall{

    }
    .ph-courses-main .ph-academy-container .seach-vidoverall .vidoverall-item{

        margin-bottom: 0.34rem;
    }
    .ph-courses-main .ph-academy-container .seach-vidoverall .vidoverall-item:first-child{

        margin-top: 0.4rem;
    }
    .ph-courses-main .ph-academy-container .seach-vidoverall .vidoverall-item .vidallitem-img{
        width: 6.9rem;
        height: 3.88rem;
        border-radius: 20px;
        overflow: hidden;
    }
    .ph-courses-main .ph-academy-container .seach-vidoverall .vidoverall-item .vidallitem-img video{
        width: 100%;
        height: 100%;
    }
    .ph-courses-main .ph-academy-container .seach-vidoverall .vidoverall-item .vidallitem-title{
        font-size: 0.28rem;
        font-weight: 500;
        color: #5d5f5f;
        margin-top: 0.25rem;
    }
</style>
<style scoped>

</style>